import { Lightbulb, Zap, UsersRound, BarChart3, BellRing, ShieldCheck } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';

const features = [
  {
    num: '01',
    icon: <Lightbulb size={24} />,
    title: 'Coupons simples et clairs',
    desc: "Obtenez des coupons faciles a comprendre, sans complexite inutile. Simple a utiliser, immediatement exploitable.",
  },
  {
    num: '02',
    icon: <Zap size={24} />,
    title: 'Pronostiqueurs talentueux',
    desc: "Nous mettons en avant les personnes qui ont un veritable talent pour les pronostics sportifs base sur leurs resultats reels.",
  },
  {
    num: '03',
    icon: <UsersRound size={24} />,
    title: 'Ouvert a tous les niveaux',
    desc: "Debutant ou expert. Explorez les coupons que tout le monde peut comprendre et utiliser efficacement.",
  },
  {
    num: '04',
    icon: <BarChart3 size={24} />,
    title: 'Classements transparents',
    desc: "Suivez les performances de chaque pronostiqueur avec des statistiques detaillees et verifiees en temps reel.",
  },
  {
    num: '05',
    icon: <BellRing size={24} />,
    title: 'Notifications intelligentes',
    desc: "Recevez une alerte des qu'un nouveau coupon est publie par vos pronostiqueurs favoris. Ne manquez rien.",
  },
  {
    num: '06',
    icon: <ShieldCheck size={24} />,
    title: 'Securite & confiance',
    desc: "Vos donnees sont protegees. Les resultats sont verifies automatiquement. Transparence totale.",
  },
];

function FeatureCard({ feature, index }) {
  const [ref, isVisible] = useScrollReveal();
  return (
    <div
      className={`feature-card ${isVisible ? 'visible' : ''}`}
      ref={ref}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <span className="card-number">{feature.num}</span>
      <div className="feature-icon-wrap">{feature.icon}</div>
      <h3>{feature.title}</h3>
      <p>{feature.desc}</p>
    </div>
  );
}

export default function Features() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="features">
      <div className={`features-header reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <span className="section-label">Pourquoi TIGOO</span>
        <h2 className="section-title">
          Une plateforme concue<br />pour performer
        </h2>
        <p className="section-sub">Tout ce dont vous avez besoin pour suivre les meilleurs talents du pronostic.</p>
      </div>
      <div className="features-grid">
        {features.map((f, i) => (
          <FeatureCard key={i} feature={f} index={i} />
        ))}
      </div>
    </section>
  );
}
